import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const linkAccountReducer = createReducer<State, Actions>(initialState, {
  [actions.deeplinkLinkAccount.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.deeplinkLinkAccount.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.deeplinkLinkAccount.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.deeplinkLinkAccount.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default linkAccountReducer;
